import { Injectable, inject } from '@angular/core';
import { ContactsApiService } from '../api/contacts.api';
import { toSignal } from '@angular/core/rxjs-interop';
import { createCombinedState } from '@at/shared';
import { filter, merge, Subject, switchMap } from 'rxjs';
import { DeleteContactRequest, HandleContactInviteRequest } from '../api';
import { UserService } from './user.service';

@Injectable()
export class ContactsService {
  readonly #userService = inject(UserService);
  readonly #api = inject(ContactsApiService);
  readonly #handleContactRequestSubject = new Subject<HandleContactInviteRequest>();
  readonly #deleteContactSubject = new Subject<DeleteContactRequest>();
  readonly #contactsVM$ = merge(
    this.#handleContactRequestSubject.asObservable(),
    this.#deleteContactSubject.asObservable(),
  );

  public readonly state = toSignal(
    createCombinedState({
      actionTrigger: this.#contactsVM$,
      fetchCall: () =>
        this.#userService.user$.pipe(
          filter((user) => !!user),
          switchMap(() => this.#api.getContacts()),
        ),
      actionCall: (request: DeleteContactRequest | HandleContactInviteRequest) => {
        if ('action' in request) {
          return this.#api.handleContactRequest(request);
        }
        return this.#api.deleteContact(request);
      },
      fetchAfterAction: true,
    }),
    { requireSync: true },
  );

  public deleteContact(contact: DeleteContactRequest) {
    this.#deleteContactSubject.next(contact);
  }

  public handleContactRequest(inviteResponse: HandleContactInviteRequest) {
    this.#handleContactRequestSubject.next(inviteResponse);
  }

  #updateContacts() {
    this.state().update();
  }
}
